<template>
    <v-card flat rounded="lg" v-bind="{ ...$attrs, loading }">
        <v-card-title class="d-block py-3">
            <v-row class="ma-n2" align="baseline">
                <v-col class="pa-2 text-subtitle-2 font-weight-bold"> {{ title }} </v-col>
                <!-- <template v-if="$scopedSlots['title-action'] || titleActionProps">
                    <v-col class="my-n2 mr-n2 pa-2" cols="auto">
                        <template v-if="$scopedSlots['title-action']">
                            <slot name="title-action" />
                        </template>
                        <template v-if="titleActionProps">
                            <v-btn small text v-bind="titleActionProps" class="px-2">
                                {{ titleActionProps.title || "더보기" }}
                            </v-btn>
                        </template>
                    </v-col>
                </template> -->
            </v-row>
            <v-spacer />
        </v-card-title>
        <v-divider class="content" />
        <slot />
    </v-card>
</template>

<script>
export default {
    props: {
        title: { type: String, default: null },
        titleActionProps: { type: Object, default: null },

        loading: { type: Boolean, default: false },
    },
    computed: {
        hasTitleAction() {
            return !!this.$scopedSlots["title-action"] || !!this.titleActionProps;
        },
    },
};
</script>

<style>
</style>